
import { useState } from 'react';

const CTASection = () => {
  const [isQuizOpen, setIsQuizOpen] = useState(false);
  const [currentStep, setCurrentStep] = useState(1);
  const [quizData, setQuizData] = useState({
    direction: '',
    type: '',
    season: ''
  });

  const quizSteps = [
    {
      id: 1,
      question: 'Куда хотите отправиться?',
      field: 'direction' as keyof typeof quizData,
      options: [
        'По России',
        'Европа',
        'Азия',
        'Африка',
        'Америка',
        'Не определился'
      ]
    },
    {
      id: 2,
      question: 'Какой тип отдыха предпочитаете?',
      field: 'type' as keyof typeof quizData,
      options: [
        'Активный туризм',
        'Экскурсионные туры',
        'Пляжный отдых',
        'Горные походы',
        'Культурные поездки',
        'Экстремальные приключения'
      ]
    },
    {
      id: 3,
      question: 'В какое время планируете поездку?',
      field: 'season' as keyof typeof quizData,
      options: [
        'Зима (декабрь-февраль)',
        'Весна (март-май)',
        'Лето (июнь-август)',
        'Осень (сентябрь-ноябрь)',
        'Гибкие даты'
      ]
    }
  ];

  const openQuiz = () => {
    setIsQuizOpen(true);
    setCurrentStep(1);
    setQuizData({ direction: '', type: '', season: '' });
    document.body.style.overflow = 'hidden';
  };

  const closeQuiz = () => {
    setIsQuizOpen(false);
    document.body.style.overflow = 'unset';
  };

  const handleOptionSelect = (value: string) => {
    const currentStepData = quizSteps.find(step => step.id === currentStep);
    if (currentStepData) {
      setQuizData(prev => ({
        ...prev,
        [currentStepData.field]: value
      }));
    }
  };

  const nextStep = () => {
    if (currentStep < quizSteps.length) {
      setCurrentStep(prev => prev + 1);
    }
  };

  const prevStep = () => {
    if (currentStep > 1) {
      setCurrentStep(prev => prev - 1);
    }
  };

  const showResults = () => {
    const params = new URLSearchParams();
    if (quizData.direction) params.append('direction', quizData.direction);
    if (quizData.type) params.append('type', quizData.type);
    if (quizData.season) params.append('season', quizData.season);
    
    const url = `/search?${params.toString()}`;
    window.location.href = url;
    closeQuiz();
  };

  const currentStepData = quizSteps.find(step => step.id === currentStep);
  const selectedValue = currentStepData ? quizData[currentStepData.field] : '';
  const canProceed = selectedValue !== '';

  return (
    <>
      <section className="bg-gradient-to-r from-[#1E88E5] to-[#0D47A1] py-16 md:py-20 lg:py-24">
        <div className="max-w-[1360px] mx-auto px-6">
          <div className="text-center max-w-4xl mx-auto">
            <h2 className="font-mulish font-bold text-3xl lg:text-4xl text-white mb-6">
              Подобрать путешествие под себя
            </h2>
            <p className="font-open-sans text-lg text-white/90 mb-8 leading-relaxed">
              Пройдите короткий опрос, и мы подберем идеальный маршрут специально для вас. 
              Учтем ваши предпочтения и опыт путешествий.
            </p>
            <button
              onClick={openQuiz}
              className="bg-white text-[#1E88E5] hover:bg-gray-50 font-open-sans font-semibold px-8 py-4 rounded-lg text-lg transition-all duration-300 transform hover:scale-105 shadow-lg whitespace-nowrap cursor-pointer"
            >
              Подобрать тур
            </button>
          </div>
        </div>
      </section>

      {/* Модальное окно с квизом */}
      {isQuizOpen && (
        <div 
          className="fixed inset-0 bg-black/50 flex items-center justify-center p-4 z-50"
          aria-modal="true"
          role="dialog"
          aria-labelledby="quiz-title"
        >
          <div className="bg-white rounded-lg max-w-lg w-full">
            <div className="p-6">
              {/* Шапка */}
              <div className="flex items-start justify-between mb-6">
                <div>
                  <h3 id="quiz-title" className="font-mulish font-bold text-xl text-gray-900 mb-2">
                    Подбор тура
                  </h3>
                  <div className="flex items-center gap-2">
                    {quizSteps.map((step) => (
                      <div
                        key={step.id}
                        className={`w-2 h-2 rounded-full transition-colors duration-300 ${
                          step.id <= currentStep ? 'bg-[#1E88E5]' : 'bg-gray-300'
                        }`}
                      />
                    ))}
                  </div>
                </div>
                <button
                  onClick={closeQuiz}
                  className="w-8 h-8 flex items-center justify-center text-gray-400 hover:text-gray-600 transition-colors duration-300 cursor-pointer"
                  aria-label="Закрыть квиз"
                >
                  <i className="ri-close-line text-xl"></i>
                </button>
              </div>

              {/* Вопрос */}
              {currentStepData && (
                <div className="mb-8">
                  <h4 className="font-mulish font-semibold text-lg text-gray-900 mb-6">
                    {currentStepData.question}
                  </h4>
                  <div className="space-y-3">
                    {currentStepData.options.map((option) => (
                      <label
                        key={option}
                        className="flex items-center p-4 border border-gray-200 rounded-lg hover:border-[#1E88E5] hover:bg-blue-50 transition-all duration-300 cursor-pointer"
                      >
                        <input
                          type="radio"
                          name={`step-${currentStep}`}
                          value={option}
                          checked={selectedValue === option}
                          onChange={() => handleOptionSelect(option)}
                          className="w-4 h-4 text-[#1E88E5] border-gray-300 focus:ring-[#1E88E5] mr-3"
                        />
                        <span className="font-open-sans text-gray-700">
                          {option}
                        </span>
                      </label>
                    ))}
                  </div>
                </div>
              )}

              {/* Кнопки навигации */}
              <div className="flex justify-between">
                {currentStep > 1 && (
                  <button
                    onClick={prevStep}
                    className="px-6 py-3 border border-gray-300 text-gray-700 hover:bg-gray-50 rounded-lg font-open-sans font-semibold transition-colors duration-300 cursor-pointer"
                  >
                    Назад
                  </button>
                )}
                <div className="ml-auto">
                  {currentStep < quizSteps.length ? (
                    <button
                      onClick={nextStep}
                      disabled={!canProceed}
                      className={`px-6 py-3 rounded-lg font-open-sans font-semibold transition-all duration-300 whitespace-nowrap cursor-pointer ${
                        canProceed
                          ? 'bg-[#1E88E5] hover:bg-[#0D47A1] text-white'
                          : 'bg-gray-300 text-gray-500 cursor-not-allowed'
                      }`}
                    >
                      Далее
                    </button>
                  ) : (
                    <button
                      onClick={showResults}
                      disabled={!canProceed}
                      className={`px-6 py-3 rounded-lg font-open-sans font-semibold transition-all duration-300 whitespace-nowrap cursor-pointer ${
                        canProceed
                          ? 'bg-[#1E88E5] hover:bg-[#0D47A1] text-white'
                          : 'bg-gray-300 text-gray-500 cursor-not-allowed'
                      }`}
                    >
                      Показать результаты
                    </button>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default CTASection;
